export const DATA_ELEM = 'mediaUploader';

export const MEDIA_UPLOADER_MULTI_CONTAINER = `${DATA_ELEM}-multiContainer`;
export const MEDIA_UPLOADER_DROP_PLACE = `${DATA_ELEM}-dropPlace`;
export const MEDIA_UPLOADER_ERRORS_CONTAINER = `${DATA_ELEM}-errorsContainer`;
export const MEDIA_UPLOADER_FILES_CONTAINER = `${DATA_ELEM}-filesContainer`;
export const MEDIA_UPLOADER_FILE = `${DATA_ELEM}-file`;

export const TYPE_URLS = {
  xlsx: 'https://cdn.centra.ai/app-static/o/mime_icon/xls.svg',
  pdf: 'https://cdn.centra.ai/app-static/o/mime_icon/pdf.svg',
  doc: 'https://cdn.centra.ai/app-static/o/mime_icon/doc.svg',
  zip: 'https://cdn.centra.ai/app-static/o/mime_icon/zip.svg',
  other: 'https://cdn.centra.ai/app-static/o/mime_icon/random.svg',
};
